<freud-dialog
	[visible]="isOpen"
	(visibleChange)="!$event && onClose.emit()"
	[modal]="true"
	[draggable]="false"
	[header]="
		step === 0
			? ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.HEADER'
			  | translate)
			: ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.HEADER'
			  | translate)
	"
>
	<div body>
		<div class="dialog-content">
			<div class="update" *ngIf="step === 0">
				<div class="zk-flex zk-flex-col zk-gap-2">
					<span class="dialog__title">
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.TITLE'
								| translate
						}}
					</span>
					<span class="zk-block dialog__subtitle">
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.SUBTITLE'
								| translate
						}}
					</span>
				</div>
				<ul class="zk-list-disc zk-mb-5 zk-pl-6">
					<li *ngIf="step === 0">
						{{
							'MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.ITEM_2'
								| translate
						}}
					</li>
				</ul>
			</div>
			<div class="zk-grid zk-mb-3">
				<freud-input-number
					currency="BRL"
					[formControl]="priceCtrl"
					mode="currency"
					[showButtons]="true"
					[step]="10"
					[invalid]="!this.priceCtrl.valid"
					[min]="0"
					[max]="1000"
					[maxFractionDigits]="0"
					[label]="
						step === 0
							? ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.FIELD_LABEL'
							  | translate)
							: ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.TITLE'
							  | translate
									: {
											value: 50
									  })
					"
				>
				</freud-input-number>
			</div>
		</div>
	</div>

	<div
		freudTemplatefooter
		class="zk-flex zk-gap-2 zk-justify-end zk-items-center"
	>
		<freud-button color="secondary" (click)="leftButtonModal()">
			{{
				step === 0
					? ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.BUTTONS.CANCEL'
					  | translate)
					: ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.BUTTONS.BACK'
					  | translate)
			}}
		</freud-button>
		<freud-button color="primary" (click)="rightButtonModal()">
			{{
				step === 0
					? ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.CONFIRM.BUTTONS.CONFIRM'
					  | translate)
					: ('MY_ACCOUNT.PLAN_SESSION.MODAL.PRICE_PER_SESSION.UPDATE.BUTTONS.SAVE'
					  | translate)
			}}
		</freud-button>
	</div>
</freud-dialog>
